<template>
	<span>
		<time :aria-label="startAriaLabel" :datetime="startDatetime" :class="{'time-start': endDisplay !== null}">
			{{ startDisplay }}<span v-if="startDisplaySuffix && startDisplaySuffix !== endDisplaySuffix" :class="format.displaySuffixClass">{{ startDisplaySuffix }}</span>
		</time>
		<span v-if="end">
			<span class="time-to">
				to
			</span>
			<time :aria-label="endAriaLabel" :datetime="endDatetime" class="time-end">
				{{ endDisplay }}<span :class="format.displaySuffixClass">{{ endDisplaySuffix }}</span>
			</time>
		</span>
	</span>
</template>

<script>
import { defineComponent } from 'vue';
export default defineComponent({
	name: 'TemporalDisplay',
	props: {
		start: {
			type: Object,
			default: null
		},
		end: { // Optional
			type: Object,
			default: null
		},
		template: {
			type: String,
			default: 'time'
		}
	},
	computed: {
		startDisplay: function() {
			return this.start ? this.start.locale('en-ltf').format(this.format.display) : null;
		},
		startDisplaySuffix: function() {
			return this.start && this.format.displaySuffix ? this.start.format(this.format.displaySuffix) : null;
		},
		startAriaLabel: function() {
			return this.start && this.format.ariaLabel ? this.start.format(this.format.ariaLabel) : null;
		},
		startDatetime: function() {
			return this.start ? this.start.format(this.format.datetime) : null;
		},

		endDisplay: function() {
			return this.end ? this.end.locale('en-ltf').format(this.format.display) : null;
		},
		endDisplaySuffix: function() {
			return this.end && this.format.displaySuffix ? this.end.format(this.format.displaySuffix) : null;
		},
		endAriaLabel: function() {
			return this.end && this.format.ariaLabel ? this.end.format(this.format.ariaLabel) : null;
		},
		endDatetime: function() {
			return this.end ? this.end.format(this.format.datetime) : null;
		},

		format: function() {
			switch (this.template) {
				case 'dateFull':
					return {
						display: 'dddd, MMMM D',
						displaySuffix: ', YYYY',
						displaySuffixClass: '',
						ariaLabel: '',
						datetime: 'YYYY-MM-DD'
					};
				case 'date':
					return {
						display: 'ddd, MMM D',
						displaySuffix: ', YYYY',
						displaySuffixClass: '',
						ariaLabel: 'dddd, MMMM D, YYYY',
						datetime: 'YYYY-MM-DD'
					};
				case 'dateShort':
					return {
						display: 'MMM D',
						displaySuffix: ', YYYY',
						displaySuffixClass: '',
						ariaLabel: 'dddd, MMMM D, YYYY',
						datetime: 'YYYY-MM-DD'
					};
				case 'time':
				default:
					return {
						display: 'h:mm',
						displaySuffix: ' A',
						displaySuffixClass: 'time-ampm',
						ariaLabel: '',
						datetime: 'HH:mm:ssZ'
					};
			}
		}
	}
});
</script>
